import { SIGNED_OUT_ROUTE_PATH } from '../constants/routeConstants';

/** Paths that hide global portal chrome (header + footer), matching route-scoped header rules. */
export function shouldShowRouteScopedPortalChrome(pathname: string): boolean {
  return (
    pathname !== '/examform' &&
    pathname !== '/session-expired' &&
    pathname !== SIGNED_OUT_ROUTE_PATH &&
    pathname !== '/login'
  );
}
